/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { colorTokens } from "theme/theme";

import type { SerializedStyles } from "@emotion/react";
import type { ButtonHTMLAttributes, FC, PropsWithChildren } from "react";

type Props = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "css"> & {
  css?: SerializedStyles | SerializedStyles[];
};

const getApplyStyles = (
  baseCss: SerializedStyles,
  extendCss: SerializedStyles | SerializedStyles[] | undefined
): SerializedStyles[] => {
  if (!extendCss) return [baseCss];
  if (Array.isArray(extendCss)) return [baseCss, ...extendCss];
  return [baseCss, extendCss];
};

/**
 * @description
 * 本ファイル作成時点では検索画面の主要アクション向けボタン
 * 追々 chakra ui 導入することを見越して src/ui には定義してない
 * chakra ui を導入しない場合は src/ui に移動しつつより汎用的な仕様にする必要あり
 */
export const BlackButton: FC<PropsWithChildren<Props>> = (props) => {
  const { children, css: extendCss, type = "button", ...restProps } = props;
  const applyStyles = getApplyStyles(rootStyle, extendCss);

  return (
    <button css={applyStyles} type={type} {...restProps}>
      {children}
    </button>
  );
};

const rootStyle = css`
  background: #000000;
  border-radius: 6px;
  border: none;
  color: ${colorTokens.colors["text.primary"].dark};
  cursor: pointer;
  width: 100%;
  &:disabled {
    background-color: #c2c2c2;
    cursor: not-allowed;
  }
`;
